import { gql } from '@apollo/client';

export const USE_HINT = gql`
    mutation useHint($url: String!) {
        useHint(url: $url) {
            status
        }
    }
`;
